import ForgotPassword from '@/views/auth/ForgotPassword'
import LoginPage from '@/views/auth/Login'
import Recovery from '@/views/auth/Recovery'
import RegisterPage from '@/views/auth/Register'
import Home from '@/views/home/Home'
import ExpertsPage from '@/views/mocked/experts/Experts'
import NeurophysicsTestsPage from '@/views/mocked/experts/neurophysics_tests/NeurophysicsTestsPage'
import HighSchoolGraduatesPage from '@/views/mocked/high_school_graduates/HighSchoolGraduates'
import FieldsOfStudyPage from '@/views/mocked/high_school_graduates/fields_of_study/FieldsOfStudyPage'
import GraduateLessonsPage from '@/views/mocked/high_school_graduates/graduate_lessons/GraduateLessonsPage'
import ProposedProfessionsPage from '@/views/mocked/high_school_graduates/proposed_professions/ProposedProfessionsPage'
import UniversityBasePage from '@/views/mocked/high_school_graduates/university_base/UniversityBasePage'
import HRPage from '@/views/mocked/hr/HrPage'
import MyPersonalDevelopmentPage from '@/views/mocked/my_personal_development/MyPersonalDevelopment'
import StudentsPage from '@/views/mocked/students/StudentsPage'
import CareerPathsPage from '@/views/mocked/students/career_paths/CareerPathsPage'
import EarningsPage from '@/views/mocked/students/earnings/EarningsPage'
import JobMapPage from '@/views/mocked/students/job_map/JobMapPage'
import TestResultsPage from '@/views/results/TestResultsPage'
import ResultsHistoryDetailsPage from '@/views/test_history/ResultsHistoryDetailsPage'
import ResultsHistoryPage from '@/views/test_history/ResultsHistoryPage'
import TestDetails from '@/views/tests/TestDetails'
import TestSession from '@/views/tests/TestSession'
import paths from './paths'
import UserProfileSettingsPage from '@/views/user_profile_settings/UserProfileSettings'
const createRoute = (path: string, component: React.ComponentType) => ({
  path,
  component
})

/**
 * Routes configuration object.
 */
const routes = {
  public: [],
  nonAuthenticated: [
    createRoute(paths.LOGIN, LoginPage),
    createRoute(paths.REGISTER, RegisterPage),
    createRoute(paths.FORGOT_PASSWORD, ForgotPassword),
    createRoute(paths.LOGIN + '/recovery', Recovery)
  ],
  authenticated: [
    createRoute(paths.HOME, Home),
    createRoute(paths.TEST_DETAILS, TestDetails),
    createRoute(paths.TEST_SESSION, TestSession),
    createRoute(paths.EXPERTS, ExpertsPage),
    createRoute(paths.EXPERTS_NEUROPHYSICS_TESTS, NeurophysicsTestsPage),
    createRoute(paths.HIGH_SCHOOL_GRADUATES, HighSchoolGraduatesPage),
    createRoute(
      paths.HIGH_SCHOOL_GRADUATES_PROPOSED_PROFESSIONS,
      ProposedProfessionsPage
    ),
    createRoute(paths.HIGH_SCHOOL_GRADUATES_FIELDS_OF_STUDY, FieldsOfStudyPage),
    createRoute(paths.HIGH_SCHOOL_GRADUATES_UNIVERSITY_BASE, UniversityBasePage),
    createRoute(paths.HIGH_SCHOOL_GRADUATES_GRADUATE_LESSONS, GraduateLessonsPage),
    createRoute(paths.STUDENTS, StudentsPage),
    createRoute(paths.STUDENTS_CAREER_PATHS, CareerPathsPage),
    createRoute(paths.STUDENTS_JOB_MAP, JobMapPage),
    createRoute(paths.STUDENTS_EARNINGS, EarningsPage),
    createRoute(paths.TEST_RESULT_DETAILS, TestResultsPage),
    createRoute(paths.RESULT_HISTORY, ResultsHistoryPage),
    createRoute(paths.RESULT_DETAILS, ResultsHistoryDetailsPage),
    createRoute(paths.HR, HRPage),
    createRoute(paths.MY_DEVELOPMENT, MyPersonalDevelopmentPage),
    createRoute(paths.USER_PROFILE_SETTINGS,UserProfileSettingsPage)
  ]
}

export default routes
